import { DatePicker } from '@maxtropy/components';
import { Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { FC, memo, useMemo } from 'react';
import styles from './index.module.scss';

export enum IndexTimeActive {
  THIS_MONTH = 'MONTH',
  THIS_YEAR = 'YEAR',
}

export type RangeValue = Dayjs | null;

export interface SwitchDateProps {
  activeKey?: IndexTimeActive;
  value?: RangeValue;
  setActiveKey?: (activeKey: IndexTimeActive) => void;
  setValue?: (value: Dayjs) => void;
}

const SwitchDate: FC<SwitchDateProps> = props => {
  const { activeKey, value, setActiveKey, setValue } = props;

  const picker = useMemo(() => {
    if (activeKey === IndexTimeActive.THIS_MONTH) {
      return 'month';
    } else {
      return 'year';
    }
  }, [activeKey]);

  return (
    <Space size={12} className={styles.switchDate}>
      <Space size={8}>
        <div
          className={`${styles.dateBtn} ${activeKey === IndexTimeActive.THIS_MONTH && styles.active}`}
          onClick={() => {
            setActiveKey?.(IndexTimeActive.THIS_MONTH);
            setValue?.(dayjs());
          }}
        >
          月
        </div>
        <div
          className={`${styles.dateBtn} ${activeKey === IndexTimeActive.THIS_YEAR && styles.active}`}
          onClick={() => {
            setActiveKey?.(IndexTimeActive.THIS_YEAR);
            setValue?.(dayjs());
          }}
        >
          年
        </div>
      </Space>
      <DatePicker
        picker={picker}
        value={value}
        style={{ width: '180px', padding: '2px 11px 2px' }}
        getPopupContainer={() => document.getElementById('full_screen_box') ?? document.body}
        onChange={dates => setValue?.(dates)}
        allowClear={false}
      />
    </Space>
  );
};

export default memo(SwitchDate);
